<template>
  <div class="section-subscribe">
    <div class="subcontainer">
      <div class="subrow">
        <div class="subcol">
          <p class="textsub">{{ $t('RedesSociais') }}</p>
          <div class="mail-subscribe-box">
            <a :href="urlFacebook" target="_blank" class="margin" v-if="urlFacebook">
              <font-awesome-icon :icon="['fab', 'facebook-square']" size="2x" />
            </a>

            <a :href="urlInstagram" target="_blank" class="margin" v-if="urlInstagram">
              <font-awesome-icon :icon="['fab', 'instagram-square']" size="2x" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FunctionsMixin from '@/utils/functionsMixin.js'
export default {
  name: 'Cardapios-RedesSociais',

  mixins: [FunctionsMixin],

  computed: {
    urlFacebook() {
      return this.$store.state.configuracoes === null
        ? false
        : this.$store.state.configuracoes.redessociais.redesocial.facebook;
    },
    urlInstagram() {
      return this.$store.state.configuracoes === null
        ? false
        : this.$store.state.configuracoes.redessociais.redesocial.instagram;
    }
  }
};
</script>

<style scoped>
.margin {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
